import styled from 'styled-components';

export const Page = styled.div`
  min-height: 60vh;
`;

export const Hero = styled.section`
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.green[800]} 0%,
    ${({ theme }) => theme.colors.green[600]} 58%,
    ${({ theme }) => theme.colors.orange[500]} 100%
  );
  padding: 56px 16px 72px;
  color: #fff;
`;

export const HeroInner = styled.div`
  max-width: ${({ theme }) => theme.container};
  margin: 0 auto;
  display: grid;
  gap: 16px;

  h1 {
    margin: 0;
    font-size: clamp(2rem, 4vw, 3.2rem);
    line-height: 1.1;
  }

  p {
    margin: 0;
    max-width: 760px;
    line-height: 1.75;
    color: rgba(255, 255, 255, 0.92);
    font-size: 1.02rem;
    white-space: pre-wrap;
  }
`;

export const HeroTag = styled.span`
  justify-self: start;
  padding: 7px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.2);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-size: 0.76rem;
  font-weight: 700;
`;

export const ContentSection = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: -38px auto 0;
  padding: 0 16px 56px;
`;

export const IntroCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 20px;
  box-shadow: ${({ theme }) => theme.shadows.md};
  padding: 24px;
  margin-bottom: 22px;

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.gray[700]};
    line-height: 1.75;
    white-space: pre-wrap;
  }
`;

export const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 18px;
`;

export const ServiceCard = styled.article`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 18px;
  padding: 22px;
  box-shadow: ${({ theme }) => theme.shadows.sm};
  min-height: 220px;
  display: grid;
  align-content: start;
  gap: 12px;

  h2 {
    margin: 0;
    color: ${({ theme }) => theme.colors.green[700]};
    font-size: 1.2rem;
    line-height: 1.3;
  }

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.gray[700]};
    line-height: 1.7;
    white-space: pre-wrap;
  }
`;

export const ServiceIndex = styled.span`
  width: 42px;
  height: 42px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.green[50]};
  color: ${({ theme }) => theme.colors.green[700]};
  font-weight: 700;
`;

export const EmptyState = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px dashed ${({ theme }) => theme.colors.gray[300]};
  border-radius: 18px;
  padding: 28px;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray[600]};
  line-height: 1.7;
`;
